import {questionsEng, questionsUkr, validPairsForOscilloscope} from "../constants/constants";
import useStore from "../store/store";

export const isValidPair = (durationGeneratorsRegulatorValue, amplitudeGeneratorsRegulatorValue) => {
    const store = useStore.getState();


    const index = validPairsForOscilloscope.findIndex(
        pair => pair.duration == durationGeneratorsRegulatorValue && pair.amplitude == amplitudeGeneratorsRegulatorValue
    );

    if (index !== -1) {

        store.changeValuesStatus(index);

        validPairsForOscilloscope.forEach(pair => {
            if (durationGeneratorsRegulatorValue === pair.duration) {
                if ((amplitudeGeneratorsRegulatorValue > 0.00 || amplitudeGeneratorsRegulatorValue > 0) && amplitudeGeneratorsRegulatorValue < 0.1 * pair.amplitude) {
                    store.changeBeforeBorderValueMin(true);

                }
                if (amplitudeGeneratorsRegulatorValue > 0.1 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.2 * pair.amplitude) {
                    store.changeBeforeBorderValueMin1(true);

                }
                if (amplitudeGeneratorsRegulatorValue > 0.2 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.3 * pair.amplitude) {
                    store.changeBeforeBorderValueMin11(true);
                }
                if (amplitudeGeneratorsRegulatorValue > 0.3 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.4 * pair.amplitude) {

                    store.changeBeforeBorderValueMin12(true);
                }
                if (amplitudeGeneratorsRegulatorValue > 0.4 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.5 * pair.amplitude){

                    store.changeBeforeBorderValueMin2(true);

                }
                if (amplitudeGeneratorsRegulatorValue > 0.5 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.6 * pair.amplitude){
                    store.changeBeforeBorderValueMiddle(true);

                }
                if (amplitudeGeneratorsRegulatorValue > 0.6 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.7 * pair.amplitude){
                    store.changeBeforeBorderValueMiddle2(true);
                }
                if (amplitudeGeneratorsRegulatorValue > 0.7 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.8 * pair.amplitude){
                    store.changeBeforeBorderValueMiddle3(true);

                }
                if (amplitudeGeneratorsRegulatorValue > 0.8 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.9 * pair.amplitude){
                    store.changeBeforeBorderValueMiddle4(true);

                }
                if (amplitudeGeneratorsRegulatorValue > 0.9 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.9999 * pair.amplitude){
                    store.changeBeforeBorderValueMax(true);

                }
                if (amplitudeGeneratorsRegulatorValue > 0.9999 * pair.amplitude){
                    store.changeBorderValue(true);

                }
                if (amplitudeGeneratorsRegulatorValue === 0 || amplitudeGeneratorsRegulatorValue === 0.00) {
                    store.changeZeroBorderValue(true);
                }
            }
        });

    }

    validPairsForOscilloscope.forEach(pair => {
        if (durationGeneratorsRegulatorValue === pair.duration) {
            if ((amplitudeGeneratorsRegulatorValue > 0.00 || amplitudeGeneratorsRegulatorValue > 0) && amplitudeGeneratorsRegulatorValue < 0.1 * pair.amplitude) {
                store.changeBeforeBorderValueMin(true);

            }
            if (amplitudeGeneratorsRegulatorValue > 0.1 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.2 * pair.amplitude) {
                store.changeBeforeBorderValueMin1(true);

            }
            if (amplitudeGeneratorsRegulatorValue > 0.2 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.3 * pair.amplitude) {
                store.changeBeforeBorderValueMin11(true);
            }
            if (amplitudeGeneratorsRegulatorValue > 0.3 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.4 * pair.amplitude) {

                store.changeBeforeBorderValueMin12(true);
            }
            if (amplitudeGeneratorsRegulatorValue > 0.4 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.5 * pair.amplitude){

                store.changeBeforeBorderValueMin2(true);

            }
            if (amplitudeGeneratorsRegulatorValue > 0.5 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.6 * pair.amplitude){
                store.changeBeforeBorderValueMiddle(true);

            }
            if (amplitudeGeneratorsRegulatorValue > 0.6 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.7 * pair.amplitude){
                store.changeBeforeBorderValueMiddle2(true);
            }
            if (amplitudeGeneratorsRegulatorValue > 0.7 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.8 * pair.amplitude){
                store.changeBeforeBorderValueMiddle3(true);

            }
            if (amplitudeGeneratorsRegulatorValue > 0.8 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.9 * pair.amplitude){
                store.changeBeforeBorderValueMiddle4(true);

            }
            if (amplitudeGeneratorsRegulatorValue > 0.9 * pair.amplitude && amplitudeGeneratorsRegulatorValue < 0.9999 * pair.amplitude){
                store.changeBeforeBorderValueMax(true);

            }
            if (amplitudeGeneratorsRegulatorValue > 0.9999 * pair.amplitude){
                store.changeBorderValue(true);

            }
            if (amplitudeGeneratorsRegulatorValue === 0 || amplitudeGeneratorsRegulatorValue === 0.00) {
                store.changeZeroBorderValue(true);
            }
        }
    });

    return true;
};

export const getRandomQuestions = () => {
    const store = useStore.getState();

    const randomQuestions = [];
    let shuffledQuestions

    if (store.eng) {
        shuffledQuestions = questionsEng.sort(() => 0.5 - Math.random());
    }else{
        shuffledQuestions = questionsUkr.sort(() => 0.5 - Math.random());
    }

    for (let i = 0; i < 10; i++) {
        randomQuestions.push(shuffledQuestions[i]);
    }
    return randomQuestions;
};

export const getFutureDate = () => {
    const futureDate = new Date(Date.now() + 10 * 24 * 60 * 60 * 1000);
    return futureDate.getDate() + '-' + (futureDate.getMonth() + 1) + '-' + futureDate.getFullYear()
}

export function xorEncryptDecrypt(data, key) {
    return data.split('').map((char, index) => String.fromCharCode(char.charCodeAt(0) ^ key.charCodeAt(index % key.length))).join('');
}